export const initialState = {
    tenantList: [],
    tenantDetails: null,
    masterSettingList: [],
    masterSetting: null,
    defaultTemplateList: [],
};

const state = { ...initialState };

export default state;